module.exports = __webpack_public_path__ + "static/img/装饰19.8a6396d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/jewelryPendant/imgs/装饰19.svg
// module id = GI9O
// module chunks = 2